import axios from "axios";

// API Base endpoint for local and live
const api = axios.create({
  // baseURL: "http://localhost:7045/api/v1",
   baseURL: "https://backend.argone.ng/api/v1",
  // baseURL: "https://argoneworlduserbackend.findfood.ng/api/v1",
});

export default api;



